import React from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField,} from '@mui/material';

interface RolModalProps {
    open: boolean;
    onClose: () => void;
    formik: any;
}

const RolModal: React.FC<RolModalProps> = ({open, onClose, formik}) => {
    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
            <form onSubmit={formik.handleSubmit}>
                <DialogTitle>{formik.values.id ? 'Rol Düzenle' : 'Yeni Rol Oluştur'}</DialogTitle>
                <DialogContent>
                    <TextField
                        fullWidth
                        label="Rol Adı"
                        name="rolAdi"
                        value={formik.values.rolAdi}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.rolAdi && Boolean(formik.errors.rolAdi)}
                        helperText={formik.touched.rolAdi && formik.errors.rolAdi}
                        sx={{mt: 2}}
                    />
                    <TextField
                        fullWidth
                        label="Rol Tipi"
                        name="rolTipi"
                        value={formik.values.rolTipi}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.rolTipi && Boolean(formik.errors.rolTipi)}
                        helperText={formik.touched.rolTipi && formik.errors.rolTipi}
                        sx={{mt: 2}}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>İptal</Button>
                    <Button color="primary" type="submit">
                        Kaydet
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};

export default RolModal;
